export default "__VITE_ASSET__a7b84b46__"